import React from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from '../../lib/money'

const DepositPayment = ({ depositAmount }) => (
  <div className="share-details pl-2 py-1 emerald-green">
    <h4>
      <FormattedMessage
        id="depositPayment.title"
        defaultMessage="Deposit payment"
      /><br />
      <span className="small-print">
        <FormattedMessage
          id="depositPayment.reserveNotice"
          defaultMessage="Charged now to reserve the inventory and
            credited to you at group completion"
        />
      </span>
    </h4>
    <div><b>{format(depositAmount)}</b></div>
  </div>
);

DepositPayment.defaultProps = {
  depositAmount: {
    amountCents: 0,
    currencyCode: 'USD',
  },
};

export default DepositPayment;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/deposit-payment.js